import { reatomAsync, withDataAtom } from "@reatom/async";

import { APIKnowledge } from "./knowledge.constants";

export const knowledgePage = reatomAsync(async (ctx, slug: string) => {
  const res = await fetch(
    `${APIKnowledge}/items/docsPoizon?filter[slug][_eq]=${slug}&fields=id,title,slug,order,content,status`,
  );

  const json = await res.json();
  return json.data?.[0] ?? null;
}, "knowledgePage").pipe(withDataAtom(null));
